import React from 'react';
import { FaTrashAlt, FaArrowRight } from 'react-icons/fa';
import { TEMPLATE_ICONS } from './templateUtils';

function TemplateCard({ template, onSelect, onDelete }) {
  const Icon = TEMPLATE_ICONS[template.icon] || TEMPLATE_ICONS.saved;
  return (
    <div className="group relative" data-testid={`template-card-${template.template_id}`}>
      <button
        type="button"
        onClick={() => onSelect(template)}
        className="w-full text-left p-4 rounded-xl border border-gray-200 bg-white hover:border-emerald-500 hover:shadow-md transition-[border-color,box-shadow] duration-200"
        data-testid={`select-template-${template.template_id}`}
      >
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">
            <Icon />
          </span>
          <div className="min-w-0 pr-6">
            <p className="font-semibold text-gray-800 truncate">{template.name}</p>
            <p className="text-xs text-gray-500 truncate">
              {template.tasks.length} tasks{template.created_by_name ? ` · saved by ${template.created_by_name}` : ''}
            </p>
          </div>
        </div>
      </button>
      {template.can_delete && (
        <button
          type="button"
          onClick={() => onDelete(template)}
          className="absolute top-3 right-3 p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
          title="Delete saved template"
          data-testid={`delete-template-${template.template_id}`}
        >
          <FaTrashAlt className="text-xs" />
        </button>
      )}
    </div>
  );
}

export function TemplateChooser({ builtin, saved, loading, onSelect, onDelete, onSkip, skipLabel = "Skip, I'll add tasks myself" }) {
  if (loading) return <p className="text-gray-500 py-8 text-center" data-testid="templates-loading">Loading templates...</p>;
  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-3" data-testid="builtin-templates">
        {builtin.map((t) => <TemplateCard key={t.template_id} template={t} onSelect={onSelect} />)}
      </div>
      {saved.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-2">Your family's templates</h4>
          <div className="grid sm:grid-cols-2 gap-3" data-testid="saved-templates">
            {saved.map((t) => <TemplateCard key={t.template_id} template={t} onSelect={onSelect} onDelete={onDelete} />)}
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={onSkip}
        className="w-full flex items-center justify-center gap-2 py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
        data-testid="skip-template-btn"
      >
        {skipLabel} <FaArrowRight className="text-xs" />
      </button>
    </div>
  );
}
